import React from 'react';
import { computationDecimalScale, computationValueLength } from '../../../../common/helper';
import FormsyInputField from '../../../elements/FormsyInputField';
import FormsySelect from '../../../elements/FormsySelect';
import FormFields from "../../formFields/computation.json";
const PAYMENT_FROM_FINANCIER_DETAILS = FormFields?.PAYMENT_FROM_FINANCIER_DETAILS;
const PAID_THROUGH_DI_OPTIONS = [
    {value: "dealer_incentive", label: "Dealer Incentive"}
]
const shouldShowField = (field, computationDetails) => {
  if (field.name === "mode_of_vat_back_received") {
    return computationDetails?.is_vat_back_involved === "Yes";
  }
  if (field.name === "vat_back_percent" || field.name === "vat_back_amount") {
    return (computationDetails?.is_vat_back_involved === "Yes" &&( computationDetails?.mode_of_vat_back_received === "along_with_di_payment" || computationDetails?.mode_of_vat_back_received === "as_additional_revenue"));
  }

  // Final amount only in DI Payment (only if VAT back involved = yes)
  if (field.name === "final_amount_received_from_financer") {
    return (computationDetails?.is_vat_back_involved === "Yes" && computationDetails?.mode_of_vat_back_received === "along_with_di_payment");
  }

  // Case B: Additional Revenue → Show Is WHT deducted question (only if VAT back involved = yes)
  if (field.name === "is_wht_deducted") {
    return (computationDetails?.is_vat_back_involved === "Yes" &&computationDetails?.mode_of_vat_back_received === "as_additional_revenue");
  }

  // Case B + WHT = Yes → Show extra fields (only if VAT back involved = yes)
  const whtFields = [
    "requested_tax_wht_deduction_on_di_percentage",
    "requested_tax_wht_deduction_on_di_amount",
    "final_di_amount_from_financier_to_carmude_net_of_tax",
    "tax_wht_deduction_vat_back_percent",
    "tax_wht_deduction_vat_back_amount",
    "final_vat_back_amount"
  ];
  if (whtFields.includes(field.name)) {
    return ( computationDetails?.is_vat_back_involved === "Yes" && computationDetails?.mode_of_vat_back_received === "as_additional_revenue" && computationDetails?.is_wht_deducted === "Yes");
  }
  return true;
};
const isOptionDefaultChecked = (lead, option, field, computationDetails) => {
  const valueFromLead = lead?.leadDetail?.lead_computation_details?.[option.name];
  if (option.name === "is_vat_back_on_mi" || option.name === "is_vat_back_involved") {
    if (valueFromLead === undefined || valueFromLead === null) {
      return option.value.toLowerCase() === "no"; 
    }
    return String(valueFromLead).toLowerCase() === String(option.value).toLowerCase();
  }
 if (option.name === "wht_on_gross") {
    if (valueFromLead === undefined || valueFromLead === null) {
      return option.value.toLowerCase() === "yes"; 
    }
    return String(valueFromLead).toLowerCase() === String(option.value).toLowerCase();
  }
  const result = String(valueFromLead ?? computationDetails?.[option.name] ?? "").toLowerCase() === String(option.value).toLowerCase();
  return result;
};



const PaymentFromFinancierDetails = ({
    computationDetails,
    handlePatternFormatChange,
    handleInputChange,
    allfieldsReadonly,
    isRegeneratedFieldActive,
    financierId,
    lead,
    handleRadioChange,
    advanceDiPaid,
    dealerIncentiveSelectAllowed,
    allOptions,
    handleSelectChange,
}) => {
    const showMiFields =computationDetails.mi_percentage_gross  != null && computationDetails.tax_percentage_wht_on_mi != null;
    const miOnlyFields = ['mi_percentage_gross','mi_amount_gross', 'tax_percentage_wht_on_mi', 'tax_amount_wht_on_mi', 'mi_amount_net', 'is_vat_back_on_mi', 'vat_back_on_mi_amount','final_mi'];
    return <section className='loan-detail-filed-bg loan-input-filed-bg'>
        <h2>Payment From Financier Details</h2>
    {PAYMENT_FROM_FINANCIER_DETAILS.map((field) => {
        const isMiOnlyField = miOnlyFields.includes(field.name);

        if (isMiOnlyField && !showMiFields) {
            return null;
        }

        if (shouldShowField(field, computationDetails)) {
            if (
                ["text", "number-format"].includes(field.type) &&
                (field.id !== "vat_back_on_mi_amount" ||
                    computationDetails?.["is_vat_back_on_mi"]?.toLowerCase() === "yes")
            ) {
                return (
                    <fieldset className={`form-filed ${field.label.length >= 25 ? 'col-md-12' : 'col-md-6'}`} key={field.id}>
                        <FormsyInputField
                            id={field.id}
                            name={field.name}
                            type={field.type}
                            value={computationDetails?.[field.name]}
                            placeholder=" "
                            {...(field.type === "number-format"
                                ? {
                                    thousandsGroupStyle: "thousand",
                                    thousandSeparator: ',',
                                    decimalSeparator: '.'
                                }
                                : {})}
                            label={field.label}
                            onChange={
                                field.type === "number-format"
                                    ? (data) => handlePatternFormatChange(data, field.name)
                                    : handleInputChange
                            }
                            format={field.ApplyNumberformat ? field.format : ""}
                            validations={field.validations}
                            validationError={
                                computationDetails?.[field.name] ? field.validationError : ""
                            }
                            readOnly={field.readOnly || allfieldsReadonly || isRegeneratedFieldActive(field?.name)}
                            required={field.required}
                            decimalScale={computationDecimalScale(financierId)}
                            valueLength={computationValueLength(financierId)}
                            isSeparateLine={(showMiFields && ['mi_percentage_gross', 'advance_amount_paid'].includes(field.name))}
                            isToolTipForWht={computationDetails.wht_on_gross === 'No'}
                        />
                    </fieldset>
                );
            } else if (field.type === 'radio') {
                return (
                    <>
                    {['advance_amount_paid','is_vat_back_involved'].includes(field.name) && <div className="col-md-12 full-width-line-radio"></div>}  
                    <fieldset  className={`form-filed col-md-12 radio-btn radio-type-txt ${field.name === "mode_of_vat_back_received" ? "wrap-fieldset" : ""}`}key={field.id}>
                        <label className="form-label">{field.label}</label>
                        {field.options.map((option) => (
                            <div className="custom-control custom-checkbox" key={option.value}>
                                <input
                                    id={option.value}
                                    type="radio"
                                    className="custom-control-input"
                                    name={option.name}
                                    value={option.value}
                                    defaultChecked={isOptionDefaultChecked(lead, option, field, computationDetails)}
                                    onChange={handleRadioChange}
                                    disabled={allfieldsReadonly || isRegeneratedFieldActive(field?.name)}
                                    aria-label={`for ${option.name}`}
                                />
                                <label htmlFor={option.id} className="custom-control-label">{option.label}</label>
                            </div>
                        ))}
                    </fieldset>
                    </>
                );
            } else if (
                field.type === "dropdown" &&
                (field.name !== "paid_through" || advanceDiPaid?.advance_amount_paid === "yes")
            ) {
                return (
                    <fieldset key={field.id} className="single-select col-md-12">
                        <FormsySelect
                            name={field.name}
                            id={field.id}
                            inputProps={{
                                options:
                                    field?.name === "paid_through" && dealerIncentiveSelectAllowed
                                        ? PAID_THROUGH_DI_OPTIONS
                                        : allOptions?.[field?.optionsKey],
                                placeholder: field.label,
                                className: "react-select",
                                classNamePrefix: "react-select",
                                value:
                                    allOptions &&
                                    allOptions[field.optionsKey] &&
                                    allOptions[field.optionsKey].filter(({ value }) =>
                                        field.name === "paid_through"
                                            ? value === computationDetails?.[field.name]
                                            : Number(value) === computationDetails?.[field.name]
                                    ),
                                isDisabled:
                                    field.readOnly ||
                                    allfieldsReadonly ||
                                    isRegeneratedFieldActive(field?.name)
                            }}
                            required={field.required}
                            value={computationDetails && computationDetails[field.name]}
                            onChange={(data) => handleSelectChange(data, field.name)}
                        />
                    </fieldset>
                );
            } else {
                return <></>;
            }
        } else {
            return null;
        }
    })}
    </section>;
};


export default PaymentFromFinancierDetails;
